import { IS_CALENDAR_MOCK_INIT_SECTIONS_ENABLED } from '../constants/calendarMock'
import { ROUTE_UI_SECTION_NAME } from '../constants/route'

function getCalendarMockUiSections() {
  return { [ROUTE_UI_SECTION_NAME.calendar]: true }
}

function getCalendarMockSections() {
  return {
    [ROUTE_UI_SECTION_NAME.settingsCalendar]: {
      permissions: { can_view: true },
    },
  }
}

// TODO: drop once init serves the calendar keys (TM-01-46)
export function withCalendarMockUiSections(uiSections) {
  return IS_CALENDAR_MOCK_INIT_SECTIONS_ENABLED
    ? { ...getCalendarMockUiSections(), ...uiSections }
    : uiSections
}

export function withCalendarMockSections(sections) {
  return IS_CALENDAR_MOCK_INIT_SECTIONS_ENABLED
    ? { ...getCalendarMockSections(), ...sections }
    : sections
}
